"use client";

import React, { createContext, useContext, FC, memo, ReactNode } from "react";
import { DesktopProposalTableProps, MobileProposalTableProps, ProposalTableComponentProps } from "../lib/type";
import { useProposalTable } from "../lib/useProposalTable";
import { contextFieldNames, ProposalDataType } from "../lib/const";

interface ProposalTableContextValue extends DesktopProposalTableProps, MobileProposalTableProps {
  form: ReturnType<typeof useProposalTable>["form"];
  isTariffCalcPending?: boolean;
  proposalData: ProposalDataType;
  onPdfFileClick?: () => void;
}

const ProposalTableContext = createContext<ProposalTableContextValue>(
  {} as ProposalTableContextValue
);

export const useProposalTableContext = () => {
  return useContext(ProposalTableContext);
};


export const ProposalTableProvider: FC<ProposalTableComponentProps & { children: ReactNode }> = memo(
  (props) => {
    const {
      proposalData,
      onSelectColumnCard,
      onCancel,
      onRecalculate,
      onChangeCover,
      onHintAreaDetailsButtonPressed,
      activeColumnId,
      selectedColumnIndex,
      editingColumnIndex,
      toggleHintArea,
      openedHintAreaIndex,
      onCurrencySelectChange,
      onPdfFileClick,
      form,
      isTariffCalcPending,
    } = useProposalTable({
      columnName: props.columnName ?? "",
      columns: props.columns,
      contextFieldNames,
    });

    return (
      <ProposalTableContext.Provider
        value={{
          ...props,
          onSelectColumnCard,
          onCancel,
          onRecalculate,
          onChangeCover,
          onHintAreaDetailsButtonPressed,
          activeColumnId,
          selectedColumnIndex,
          editingColumnIndex,
          toggleHintArea,
          openedHintAreaIndex,
          onCurrencySelectChange,
          form,
          isTariffCalcPending,
          proposalData,
          onPdfFileClick
        }}
      >
        {props.children}
      </ProposalTableContext.Provider>
    );
  }
);

ProposalTableProvider.displayName = 'ProposalTableProvider'
